import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ConfigHistory.css';
import Chip from 'components/shared/Chip/Chip';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import Accordion from 'components/shared/Accordion/Accordion';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import Dropdown from 'components/shared/Dropdown/Dropdown';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import InputRange from 'components/shared/InputRange';
import moment from 'moment';
import classnames from 'classnames';

import {
  doGetAvailablePmCounters,
  doGetAvailableCmCounters,
  setDropModalOpen,
  updateConfigHistoryViewSwitch,
  updateConfigHistoryKpiCheckboxItems,
  updateConfigHistoryParamCheckboxItems,
  updateConfigHistoryLocalCountersData,
  updateStatus,
  updateConfigHistorySelectedCounters,
  updateConfigHistorySavedDataConfigs
} from 'redux/actions';
import { ConfigHistoryViewSwitchStates } from 'redux/reducers';
import {
  getFilteredKpiData,
  getFilteredParamData,
  reactTableSortOnClick,
  getCounterInterpolations,
  getNormalizedKpiId,
  toCSV,
  downloadCsvFile
} from 'common/utils/helpers';
import { defaultChartSelectionConfig, paramLabelValues, Status, LOADING_CIRCLE } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import { ExportIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import DualCalendar from 'components/shared/CalendarFilter/CalendarFilter';
import { getCountersData } from 'apis/GetCountersData';
import ConfigHistoryChart from './ConfigHistoryChart';

const hasMultipleWords = (string) => {
  return string.split(' ').length > 1;
};

const splitIntoTwoParts = (string) => {
  let words = string.split(' ');
  let numOfWords = words.length;
  let lastPart = words[numOfWords - 1];
  let firstPart = words.slice(0, numOfWords - 1).join(' ');

  return { firstPart, lastPart };
};

const AZIMUTH_MIN = -76;
const AZIMUTH_MAX = 361;
const ELEVATION_MIN = -35;
const ELEVATION_MAX = 361;
const DOWNLINK_GAIN_V_MIN = 12;
const DOWNLINK_GAIN_V_MAX = 52;
const DOWNLINK_GAIN_H_MIN = 14;
const DOWNLINK_GAIN_H_MAX = 54;
const UPLINK_GAIN_V_MIN = 18;
const UPLINK_GAIN_V_MAX = 56;
const UPLINK_GAIN_H_MIN = 16;
const UPLINK_GAIN_H_MAX = 53;

class ConfigHistory extends Component {
  constructor(props) {
    super(props);
    this.metricDropdown = React.createRef();
    this.state = {
      timeDropdownItems: null,
      localSavedDataConfig: null,
      timeSpanValue: 0,
      metricCustomDropdownModes: {},
      timeDropdownLabel: '',
      updateTableKey: 0,
      isDraggingSlider: false,
      deviceTwin_reported_antenna_direction_beamAzimuth: {
        min: AZIMUTH_MIN,
        max: AZIMUTH_MAX,
        minValue: AZIMUTH_MIN,
        maxValue: AZIMUTH_MAX,
        inputMin: AZIMUTH_MIN,
        inputMax: AZIMUTH_MAX
      },
      deviceTwin_reported_antenna_direction_beamElevation: {
        min: ELEVATION_MIN,
        max: ELEVATION_MAX,
        minValue: ELEVATION_MIN,
        maxValue: ELEVATION_MAX,
        inputMin: ELEVATION_MIN,
        inputMax: ELEVATION_MAX
      },
      deviceTwin_reported_VDL_Gain_value: {
        min: DOWNLINK_GAIN_V_MIN,
        max: DOWNLINK_GAIN_V_MAX,
        minValue: DOWNLINK_GAIN_V_MIN,
        maxValue: DOWNLINK_GAIN_V_MAX,
        inputMin: DOWNLINK_GAIN_V_MIN,
        inputMax: DOWNLINK_GAIN_V_MAX
      },
      deviceTwin_reported_HDL_Gain_value: {
        min: DOWNLINK_GAIN_H_MIN,
        max: DOWNLINK_GAIN_H_MAX,
        minValue: DOWNLINK_GAIN_H_MIN,
        maxValue: DOWNLINK_GAIN_H_MAX,
        inputMin: DOWNLINK_GAIN_H_MIN,
        inputMax: DOWNLINK_GAIN_H_MAX
      },
      deviceTwin_reported_VUL_Gain_value: {
        min: UPLINK_GAIN_V_MIN,
        max: UPLINK_GAIN_V_MAX,
        minValue: UPLINK_GAIN_V_MIN,
        maxValue: UPLINK_GAIN_V_MAX,
        inputMin: UPLINK_GAIN_V_MIN,
        inputMax: UPLINK_GAIN_V_MAX
      },
      deviceTwin_reported_HUL_Gain_value: {
        min: UPLINK_GAIN_H_MIN,
        max: UPLINK_GAIN_H_MAX,
        minValue: UPLINK_GAIN_H_MIN,
        maxValue: UPLINK_GAIN_H_MAX,
        inputMin: UPLINK_GAIN_H_MIN,
        inputMax: UPLINK_GAIN_H_MAX
      }
    };
  }

  componentDidMount() {
    const { deviceId, view, savedDataConfigs, updateConfigHistoryViewSwitch, updateConfigHistorySavedDataConfigs } =
      this.props;

    //default dropdown option is Past Week
    let resolution = defaultChartSelectionConfig.panelData[0].metricList[0].data;
    let time =
      savedDataConfigs && savedDataConfigs.time
        ? savedDataConfigs.time
        : defaultChartSelectionConfig.panelData[0].metricList[1].data;
    let timeSpanValue = 60 * 24 * 7; //minutes of a week

    time.forEach((item) => {
      if (item.active) timeSpanValue = item.value;
    });

    let from = moment().subtract(timeSpanValue, 'minutes').toDate().toISOString();
    let to = new Date(Date.now()).toISOString();
    this.makeFilterDataSection(from, to);
    let timeDropdownLabel = `${from} - ${to}`;

    if (savedDataConfigs) {
      if (savedDataConfigs.searchSpan && savedDataConfigs.searchSpan.startDate && savedDataConfigs.searchSpan.endDate) {
        from = savedDataConfigs.searchSpan.startDate;
        to = savedDataConfigs.searchSpan.endDate;

        timeDropdownLabel = `${from} - ${to}`;
      }

      if (savedDataConfigs.resolution) resolution = savedDataConfigs.resolution;

      if (savedDataConfigs.time) time = savedDataConfigs.time;
    }

    time.forEach((item) => {
      if (item.active === true) timeDropdownLabel = item.label;
    });

    if (!savedDataConfigs || !savedDataConfigs.searchSpan || !savedDataConfigs.resolution) {
      updateConfigHistorySavedDataConfigs(deviceId, { resolution, time, searchSpan: { startDate: from, endDate: to } });
    }

    updateConfigHistoryViewSwitch(deviceId, view);

    this.setState({
      timeDropdownItems: defaultChartSelectionConfig.panelData[0].metricList[1].data,
      timeDropdownLabel
    });
  }

  makeFilterDataSection = (from, to) => {
    const { kpisCheckboxItems, paramCheckboxItems } = this.props;

    if (!kpisCheckboxItems) {
      this.makeKpiDataSection(from, to);
    }

    if (!paramCheckboxItems) {
      this.makeParamDataSection(from, to);
    }
  };

  makeKpiDataSection = (from, to) => {
    const { doGetAvailablePmCounters, deviceId, kpisCheckboxItems, updateConfigHistoryKpiCheckboxItems } = this.props;

    !kpisCheckboxItems &&
      doGetAvailablePmCounters(
        from,
        to,
        (result) => {
          let filteredKpiData = getFilteredKpiData(result.properties);

          updateConfigHistoryKpiCheckboxItems(deviceId, filteredKpiData);
        },
        (error) => {
          console.error(error);
        }
      );
  };

  makeParamDataSection = (from, to) => {
    const { doGetAvailableCmCounters, deviceId, paramCheckboxItems, updateConfigHistoryParamCheckboxItems } =
      this.props;

    !paramCheckboxItems &&
      doGetAvailableCmCounters(
        from,
        to,
        (result) => {
          let filteredParamData = getFilteredParamData(result.properties);
          updateConfigHistoryParamCheckboxItems(deviceId, filteredParamData);
        },
        (error) => {
          console.error(error);
        }
      );
  };

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) === JSON.stringify(this.props)) {
      return;
    }

    const {
      deviceId,
      savedDataConfigs,
      kpisCheckboxItems,
      paramCheckboxItems,
      updateStatus,
      updateConfigHistorySelectedCounters,
      updateConfigHistoryLocalCountersData
    } = this.props;

    let requestCounters = [];
    let reduxCounters = [];

    if (
      savedDataConfigs &&
      kpisCheckboxItems &&
      paramCheckboxItems &&
      (savedDataConfigs.searchSpan.startDate !== prevProps.savedDataConfigs.searchSpan.startDate ||
        savedDataConfigs.searchSpan.endDate !== prevProps.savedDataConfigs.searchSpan.endDate ||
        kpisCheckboxItems !== prevProps.kpisCheckboxItems ||
        paramCheckboxItems !== prevProps.paramCheckboxItems ||
        savedDataConfigs.resolution !== prevProps.savedDataConfigs.resolution ||
        savedDataConfigs.time !== prevProps.savedDataConfigs.time)
    ) {
      let statusName = `GetCounters-${deviceId}`;
      let from = savedDataConfigs.searchSpan.startDate;
      let to = savedDataConfigs.searchSpan.endDate;
      let resolution = savedDataConfigs.resolution.find((item) => item.active === true).value;

      paramCheckboxItems &&
        paramCheckboxItems.forEach((item) => {
          if (item.active && item.value) {
            reduxCounters.push({ name: item.value, ...item });
            requestCounters.push({
              name: item.value,
              aggregation: getCounterInterpolations(getNormalizedKpiId(item.value))
            });
          }
        });

      kpisCheckboxItems &&
        kpisCheckboxItems.forEach((item) => {
          if (item.active && item.value) {
            reduxCounters.push({ name: item.value, ...item });
            requestCounters.push({
              name: item.value,
              aggregation: getCounterInterpolations(getNormalizedKpiId(item.value))
            });
          }
        });

      updateConfigHistorySelectedCounters(deviceId, reduxCounters);

      getCountersData(from, to, [deviceId], requestCounters, resolution)
        .then(async (result) => {
          updateStatus(statusName, Status.SUCCESS);
          let dimensions = result.aggregates && result.aggregates[0] && result.aggregates[0].dimension;
          let measures = result.aggregates && result.aggregates[0] && result.aggregates[0].measures;

          let countersArr = [];
          if (reduxCounters && dimensions && measures) {
            let dimensionsLength = dimensions.length;
            let countersLength = reduxCounters.length;
            for (let i = 0; i < dimensionsLength; i++) {
              let measure = measures[i];
              let newRow = { timestamp: dimensions[i] };
              for (let j = 0; j < countersLength; j++) {
                newRow[`${reduxCounters[j].name}`] = measure[j];
              }
              countersArr.push(newRow);
            }
          }
          updateConfigHistoryLocalCountersData(deviceId, countersArr);
        })
        .catch((error) => {
          console.error(error);
          updateStatus(statusName, Status.FAILURE);
        });
    }
  }

  updateCheckBoxStatus = (item, data, key) => {
    const {
      deviceId,
      updateStatus,
      updateConfigHistoryLocalCountersData,
      updateConfigHistoryParamCheckboxItems,
      updateConfigHistoryKpiCheckboxItems
    } = this.props;
    let newData = JSON.parse(JSON.stringify(data));

    for (let i in newData) {
      if ((newData[i].label && newData[i].label === item.label) || (newData[i].name && newData[i].name === item.name)) {
        newData[i].active = !newData[i].active;
        break;
      }
    }

    let statusName = `GetCounters-${deviceId}`;

    switch (key) {
      case 'kpisCheckboxItems':
        this.setState({ updateTableKey: Math.random() * 10 });
        updateStatus(statusName, Status.PENDING);
        updateConfigHistoryLocalCountersData(deviceId, []);
        updateConfigHistoryKpiCheckboxItems(deviceId, newData);
        break;
      case 'paramCheckboxItems':
        this.setState({ updateTableKey: Math.random() * 10 });
        updateStatus(statusName, Status.PENDING);
        updateConfigHistoryLocalCountersData(deviceId, []);
        updateConfigHistoryParamCheckboxItems(deviceId, newData);
        break;
      default:
        break;
    }

    this.setState({
      [key]: newData
    });
  };

  handleInputRangeOnChange = (newMinMaxObj, paramValue) => {
    this.setState({
      isDraggingSlider: true,
      [paramValue]: {
        ...this.state[paramValue],
        ...newMinMaxObj,
        inputMin: newMinMaxObj.min,
        inputMax: newMinMaxObj.max
      }
    });
  };

  handleInputRangeOnComplete = () => {
    this.setState({ isDraggingSlider: false });
  };

  handleNumberInputOnChange = (e, item, key) => {
    const val = parseFloat(e.target.value);
    const inputKey = key === 'min' ? 'inputMin' : 'inputMax';

    this.setState(
      (prevState) => ({
        [item.value]: {
          ...prevState[item.value],
          [inputKey]: val
        }
      }),
      () => {
        const { minValue, maxValue } = this.state[item.value];
        let validMin = parseFloat(this.state[item.value].inputMin);
        let validMax = parseFloat(this.state[item.value].inputMax);
        console.log('valid min before: ', validMin);
        console.log('valid max before: ', validMax);
        if (isNaN(validMin) || isNaN(validMax)) return;

        validMin = Math.max(minValue, validMin);
        validMin = Math.min(maxValue, validMin);
        validMax = Math.max(minValue, validMax);
        validMax = Math.min(maxValue, validMax);

        console.log('valid min: ', validMin);
        console.log('valid max: ', validMax);

        this.setState({
          [item.value]: {
            ...this.state[item.value],
            min: validMin,
            max: validMax
          }
        });
      }
    );
  };

  updateCheckboxItems = (data, key) => {
    let fetching = this.props.getCountersStatus === Status.PENDING;

    if (data) {
      let checkboxes = data.map((item, idx) => {
        let hoveredLabel = item.name ? item.name : item.label;
        let label = item.name ? item.name : item.label;
        let firstPartLabel = null;
        let lastPartLabel = null;
        let onlyOneSelected = item.active && this.props.selectedCounters?.length === 1;

        if (hasMultipleWords(label)) {
          let splittedLabel = splitIntoTwoParts(label);
          firstPartLabel = splittedLabel.firstPart;
          lastPartLabel = splittedLabel.lastPart;
        }

        return (
          <div key={item.value}>
            <div
              className={classnames({
                FiltersBar_CheckListContainer_Item_Div: true,
                configHistory_Disabled_Button: fetching || onlyOneSelected
              })}
              key={idx}
              data-tip={hoveredLabel}
              onClick={() => this.updateCheckBoxStatus(item, data, key)}
            >
              <Checkbox isChecked={item.active} />
              {key === 'paramCheckboxItems' || !hasMultipleWords(label) ? (
                <div className="FiltersBar_CheckListContainer_Item_Text">
                  {label.length > 20 ? label.slice(0, 18) + '...' : label}
                </div>
              ) : (
                <div className="ConfigHistoryTable_Long_KPI_Name_Box">
                  <span className="firstPart">{firstPartLabel}</span>
                  <span className="lastPart">{lastPartLabel}</span>
                </div>
              )}
            </div>
            {item.active && item.value in paramLabelValues && this.props.getCountersStatus === Status.SUCCESS && (
              <div className="parametersOpenedSection">
                <div className="rangeSliderContainer">
                  <InputRange
                    minValue={this.state[item.value].minValue}
                    maxValue={this.state[item.value].maxValue}
                    value={this.state[item.value]}
                    onChange={(newMinMaxObj) => this.handleInputRangeOnChange(newMinMaxObj, item.value)}
                    onChangeComplete={this.handleInputRangeOnComplete}
                  />
                </div>
                <div className="rangeInputContainer">
                  <input
                    className="minRange"
                    type="number"
                    value={this.state[item.value].inputMin}
                    onChange={(e) => this.handleNumberInputOnChange(e, item, 'min')}
                  />
                  <span className="rangeSeparator"> - </span>
                  <input
                    className="maxRange"
                    type="number"
                    value={this.state[item.value].inputMax}
                    onChange={(e) => this.handleNumberInputOnChange(e, item, 'max')}
                  />
                </div>
              </div>
            )}
          </div>
        );
      });
      return checkboxes;
    }
    return null;
  };

  handleViewSwitch = (viewState) => {
    const { deviceId, updateConfigHistoryViewSwitch } = this.props;

    updateConfigHistoryViewSwitch(deviceId, viewState);
  };

  customDropdownUpdate(index, mode) {
    let currentModes = this.state.metricCustomDropdownModes;

    currentModes[index] = mode;

    this.setState({ metricCustomDropdownModes: currentModes });
  }

  handleResolutionSelect = (label) => {
    const {
      deviceId,
      savedDataConfigs,
      updateStatus,
      updateConfigHistoryLocalCountersData,
      updateConfigHistorySavedDataConfigs
    } = this.props;
    let statusName = `GetCounters-${deviceId}`;

    if (savedDataConfigs && savedDataConfigs.resolution) {
      let newSavedDataConfigs = JSON.parse(JSON.stringify(savedDataConfigs));

      for (let item of newSavedDataConfigs.resolution) {
        item.active = item.label === label;
      }

      this.setState({ updateTableKey: Math.random() * 10 });
      updateConfigHistoryLocalCountersData(deviceId, []);
      updateStatus(statusName, Status.PENDING);
      updateConfigHistorySavedDataConfigs(deviceId, newSavedDataConfigs);
    }
  };

  generateChips = (searchSpan, resolution, selectedCounters) => {
    let chips = [];
    let allKpis = '';
    let numOfCounters = selectedCounters ? selectedCounters.length : 0;

    selectedCounters &&
      selectedCounters.forEach((kpi, idx) => {
        if (kpi.active) allKpis += `${kpi.label}`;
        if (idx !== numOfCounters - 1) allKpis += ', ';
      });
    searchSpan &&
      chips.push(
        <Chip
          data-tip="Time: "
          key={'time'}
          value={this.state.timeDropdownLabel}
          closeOn={() => null}
          noCloseIcon={true}
        />
      );

    resolution &&
      chips.push(
        <Chip
          data-tip="Resolution: "
          key={'resolution'}
          value={resolution.find((item) => item.active === true).label}
          closeOn={() => null}
          noCloseIcon={true}
        />
      );

    selectedCounters &&
      selectedCounters.length > 0 &&
      chips.push(<Chip data-tip="KPIs: " key={'kpis'} value={allKpis} closeOn={() => null} noCloseIcon={true} />);

    return chips;
  };

  handleFixedTimeSelect = (label) => {
    const {
      deviceId,
      savedDataConfigs,
      updateConfigHistorySavedDataConfigs,
      updateConfigHistoryLocalCountersData,
      updateStatus
    } = this.props;
    const { timeDropdownLabel } = this.state;

    let copiedSavedDataConfigs = JSON.parse(JSON.stringify(savedDataConfigs));
    let timeSpanValue = 0;
    let statusName = `GetCounters-${deviceId}`;

    if (timeDropdownLabel === label) return;

    let newTime = copiedSavedDataConfigs && copiedSavedDataConfigs.time;

    newTime &&
      newTime.forEach((item) => {
        if (item.label === label) {
          item.active = true;
          timeSpanValue = item.value;
        } else {
          item.active = false;
        }
      });

    let from = moment().subtract(timeSpanValue, 'minutes').toDate().toISOString();
    let to = new Date(Date.now()).toISOString();

    this.setState({ updateTableKey: Math.random() * 10 });
    updateConfigHistorySavedDataConfigs(deviceId, {
      ...copiedSavedDataConfigs,
      time: newTime,
      searchSpan: { startDate: from, endDate: to }
    });
    updateConfigHistoryLocalCountersData(deviceId, []);
    updateStatus(statusName, Status.PENDING);
    this.setState({ timeDropdownLabel: label });
  };
  // To handle the custom date in the configuration hidtory matrics
  handleCustomDateSelection = (startDate, endDate) => {
    const {
      deviceId,
      savedDataConfigs,
      updateConfigHistorySavedDataConfigs,
      updateConfigHistoryLocalCountersData,
      updateStatus
    } = this.props;

    const statusName = `GetCounters-${deviceId}`;

    let from = moment(startDate);
    let to = moment(endDate);

    const fromString = from.toISOString();
    const toString = to.toISOString();
    const timeDropdownLabel = `${from.format('MMM D, YYYY')} - ${to.format('MMM D, YYYY')}`;

    this.setState({
      timeDropdownLabel,
      updateTableKey: Math.random() * 10
    });

    if (savedDataConfigs && deviceId) {
      updateConfigHistorySavedDataConfigs(deviceId, {
        ...savedDataConfigs,
        searchSpan: {
          startDate: fromString,
          endDate: toString
        }
      });
      updateConfigHistoryLocalCountersData(deviceId, []);
      updateStatus(statusName, Status.PENDING);
    }

    // Reset the dropdown mode after selection
    this.customDropdownUpdate(0, null);
  };

  exportData = (rows) => {
    const { selectedCounters } = this.props;
    const csv = toCSV([{ name: 'timestamp' }, ...selectedCounters], rows);
    downloadCsvFile(csv, 'config_history_table_data.csv');
  };

  getFilteredData = (localCountersData, paramCheckboxItems) => {
    if (!localCountersData || !paramCheckboxItems) return [];

    if (paramCheckboxItems.findIndex((item) => item.active) === -1) {
      return localCountersData;
    }

    let filteredData = localCountersData.map((data) => ({ ...data }));
    paramCheckboxItems.forEach((item) => {
      if (item.active) {
        const currMin = this.state[item.value].min;
        const currMax = this.state[item.value].max;

        if (currMin < currMax) {
          filteredData.forEach((data) => {
            if (data[item.value] && (data[item.value] < currMin || data[item.value] > currMax)) {
              data[item.value] = null;
            }
          });
        }
      }
    });

    return filteredData;
  };

  render() {
    const {
      selectedCounters,
      localCountersData,
      savedDataConfigs,
      kpisCheckboxItems,
      paramCheckboxItems,
      deviceId,
      view,
      getCountersStatus,
      updateConfigHistoryLocalCountersData,
      updateConfigHistorySavedDataConfigs,
      updateStatus
    } = this.props;

    const filteredLocalCountersData = this.getFilteredData(localCountersData, paramCheckboxItems);

    let countersColumns = [];
    let timeOptions = [];
    let resolutionOptions = [];
    let chips = [];
    let parent = this;
    let from = null;
    let to = null;
    let metric = defaultChartSelectionConfig.panelData[0].metricList[1];
    let index = 0;
    let fetching = getCountersStatus === Status.PENDING;
    let error = getCountersStatus === Status.FAILURE;
    let pageSize = localCountersData ? localCountersData.length : 0;
    let overlay = null;

    if (error) {
      overlay = (
        <div className="Global_Table_ErrorOverlay">
          <div className="Global_Table_Error_Div">
            <div className="Global_Table_ErrorOverlay_Title">Error</div>
            <div className="Global_Table_ErrorOverlay_Message">
              An unknown error occurred while loading configuration history. If this problem persists, please contact us
              at
              <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
            </div>
          </div>
        </div>
      );
    }

    if (selectedCounters) {
      let copiedSelectedCounters = JSON.parse(JSON.stringify(selectedCounters));
      let numOfSelectedCounters = copiedSelectedCounters.length;

      countersColumns = copiedSelectedCounters.map((counterObj, idx) => {
        let { name, label } = counterObj;
        let isLastColumn = idx === numOfSelectedCounters - 1;
        let firstPartLabel = null;
        let lastPartLabel = null;

        if (hasMultipleWords(label)) {
          let splittedLabel = splitIntoTwoParts(label);
          firstPartLabel = splittedLabel.firstPart;
          lastPartLabel = splittedLabel.lastPart;
        }

        return {
          Header: (col) => {
            return (
              <div className="ConfigHistoryTable_Header_OuterDiv" key={idx}>
                {!hasMultipleWords(label) ? (
                  <span
                    className="ConfigHistoryTable_Header_Label"
                    data-tip={counterObj.label}
                    onClick={() => {
                      reactTableSortOnClick(parent, `config_history_${name}`);
                    }}
                  >
                    {label}
                  </span>
                ) : (
                  <div className="ConfigHistoryTable_Header_InnerDiv">
                    <span className="firstPart" data-tip={label}>
                      {firstPartLabel}
                    </span>
                    <span className="lastPart" data-tip={label}>
                      {lastPartLabel}
                    </span>
                  </div>
                )}
                {!isLastColumn ? (
                  <div className="ConfigHistoryTableHeader_ResizerSliderIcon">
                    <div className="ConfigHistoryTableHeader_ResizerSliderIcon_Bar"></div>
                  </div>
                ) : null}
              </div>
            );
          },
          id: `config_history_${name}`,
          resizable: !isLastColumn,
          minWidth: 112,
          accessor: (counter) => {
            return counter[`${name}`];
          },
          Cell: (row) => {
            return (
              <div className="ConfigHistoryTable_cellWrapper" data-tip={row.value}>
                {row.value ? row.value.toFixed(2) : 'NA'}
              </div>
            );
          },
          sortMethod: (a, b) => {
            return a > b ? 1 : -1;
          }
        };
      });
    }

    const columns = (parent) => [
      {
        Header: (col) => {
          return (
            <div className="ConfigHistoryTable_Header_OuterDiv">
              <span
                className="ConfigHistoryTable_Header_Label"
                data-tip={'Date and time'}
                onClick={() => {
                  reactTableSortOnClick(parent, 'config_history_timestamp');
                }}
              >
                Date and time
              </span>
              {selectedCounters && selectedCounters.length > 0 ? (
                <div className="ConfigHistoryTableHeader_ResizerSliderIcon">
                  <div className="ConfigHistoryTableHeader_ResizerSliderIcon_Bar"></div>
                </div>
              ) : null}
            </div>
          );
        },
        id: 'config_history_timestamp',
        resizable: false,
        width: 155,
        accessor: (counter) => {
          let { timestamp } = counter;
          let formattedTimestamp = timestamp && moment(timestamp).format('MMM D YYYY, HH:mm');
          return { timestamp, formattedTimestamp };
        },
        Cell: (row) => {
          return (
            <div className="ConfigHistoryTable_cellWrapper" data-tip={row.value.timestamp}>
              {row.value.formattedTimestamp}
            </div>
          );
        },
        sortMethod: (a, b) => {
          return a.timestamp > b.timestamp ? 1 : -1;
        },
        fixed: 'left'
      }
    ];

    let exportColumn = [
      {
        Header: (col) => {
          return <div className="ConfigHistoryTable_Header_OuterDiv ConfigHistory_Export_Button_Header_Space"></div>;
        },
        id: `config_history_table_export`,
        resizable: false,
        sortable: false,
        minWidth: 40
      }
    ];

    let paramCheckboxes = paramCheckboxItems
      ? this.updateCheckboxItems(paramCheckboxItems, 'paramCheckboxItems')
      : null;
    let kpisCheckboxes = kpisCheckboxItems ? this.updateCheckboxItems(kpisCheckboxItems, 'kpisCheckboxItems') : null;

    if (savedDataConfigs) {
      if (savedDataConfigs.resolution) resolutionOptions = savedDataConfigs.resolution.map((item) => item.label);

      if (savedDataConfigs.time) timeOptions = savedDataConfigs.time.map((item) => item.label);

      if (savedDataConfigs.searchSpan && savedDataConfigs.searchSpan.startDate && savedDataConfigs.searchSpan.endDate) {
        from = savedDataConfigs.searchSpan.startDate;
        to = savedDataConfigs.searchSpan.endDate;
      }

      chips = this.generateChips(savedDataConfigs.searchSpan, savedDataConfigs.resolution, selectedCounters);
    }

    return (
      <div className="configHistoryModal">
        <div className="configHistory_Wrapper">
          <div className="configHistory_Container">
            <div className="configHistory_Header">Configuration Metrics History</div>
            <div className="configHistory_TopBar">
              <div className="chips_Container">{chips}</div>
              <div className="buttonBars_Container">
                <button
                  className={classnames({
                    ConfigHistory_TileHeader_Button: true,
                    ConfigHistory_TileHeader_Button_Highlighted: view === ConfigHistoryViewSwitchStates.LIST
                  })}
                  onClick={() => this.handleViewSwitch(ConfigHistoryViewSwitchStates.LIST)}
                >
                  <SvgAF
                    img={IconLoader.icon_config_table_on}
                    hover={IconLoader.icon_config_table_hover}
                    tooltip={'Table View'}
                    active={view === ConfigHistoryViewSwitchStates.LIST ? IconLoader.icon_config_table : null}
                  />
                </button>

                <button
                  className={classnames({
                    ConfigHistory_TileHeader_Button: true,
                    ConfigHistory_TileHeader_Button_Highlighted: view === ConfigHistoryViewSwitchStates.SPLIT
                  })}
                  onClick={() => this.handleViewSwitch(ConfigHistoryViewSwitchStates.SPLIT)}
                >
                  <SvgAF
                    img={IconLoader.icon_config_table_charts_on}
                    hover={IconLoader.icon_config_table_charts_hover}
                    tooltip={'Split View'}
                    active={view === ConfigHistoryViewSwitchStates.SPLIT ? IconLoader.icon_config_table_charts : null}
                  />
                </button>

                <button
                  className={classnames({
                    ConfigHistory_TileHeader_Button: true,
                    ConfigHistory_TileHeader_Button_Highlighted: view === ConfigHistoryViewSwitchStates.CHART
                  })}
                  onClick={() => this.handleViewSwitch(ConfigHistoryViewSwitchStates.CHART)}
                >
                  <SvgAF
                    img={IconLoader.icon_config_charts_on}
                    hover={IconLoader.icon_config_charts_hover}
                    tooltip={'Chart View'}
                    active={view === ConfigHistoryViewSwitchStates.CHART ? IconLoader.icon_config_charts : null}
                  />
                </button>
              </div>
            </div>
            <div className="configHistory_Content">
              <div className="configHistory_LeftSection">
                <div className="configHistory_LeftScrollContainer">
                  <Accordion
                    keyId={'config-left-section'}
                    iconOpened={IconLoader.icon_arrow_open_options}
                    hoverOpened={IconLoader.icon_arrow_open_options_hover}
                    iconClosed={IconLoader.icon_arrow_closed_options}
                    hoverClosed={IconLoader.icon_arrow_closed_options_hover}
                    allowMultipleOpen
                    opened
                    iconLeft
                  >
                    <div label="Time">
                      <div
                        className={classnames({
                          ConfigHistory_TimeFilter_Box: true,
                          configHistory_Disabled_Button: fetching
                        })}
                      >
                        <Dropdown
                          ref={this.metricDropdown}
                          keyRef={true}
                          selectItem={(label) => this.handleFixedTimeSelect(label)}
                          title={this.state.timeDropdownLabel}
                          customButtonContent={
                            this.state.metricCustomDropdownModes[index] === 'CALENDAR' ? (
                              <div className="dropdownButtonCustomTimeButton">
                                <img src={IconLoader.icon_customdate} alt="" />
                                Select custom range
                              </div>
                            ) : metric.type === 'time' &&
                              (this.state.timeSpanValue == null || this.state.timeSpanValue === 0) ? (
                              <div className="dropdownButtonCustomTimeButton">
                                <span>{this.state.timeDropdownLabel}</span>
                              </div>
                            ) : null
                          }
                          data={timeOptions}
                          setCustomMode={(mode) => this.customDropdownUpdate(index, mode)}
                          customMode={this.state.metricCustomDropdownModes[index]}
                          customSection={
                            metric.type === 'time' ? (
                              <div className="customDDContentSection">
                                {this.state.metricCustomDropdownModes[index] !== 'CALENDAR' && (
                                  <div className="customDropdownList">
                                    <div
                                      onClick={() => this.customDropdownUpdate(index, 'CALENDAR')}
                                      className="customRangeSelection"
                                    >
                                      <IconAndText
                                        img={IconLoader.icon_customdate}
                                        hoverImg={IconLoader.icon_customdate}
                                        text={'Custom ranges'}
                                      />
                                    </div>
                                  </div>
                                )}
                                {this.state.metricCustomDropdownModes[index] === 'CALENDAR' && (
                                  <div className="customCalendarSection">
                                    <DualCalendar
                                      startDay={from}
                                      endDay={to}
                                      handleSubmit={(startDate, endDate) => {
                                        this.handleCustomDateSelection(startDate, endDate);
                                      }}
                                      close={() => {
                                        this.customDropdownUpdate(index, null);
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            ) : null
                          }
                          customClose={() => this.customDropdownUpdate(index, null)}
                        />
                      </div>
                    </div>
                    <div label="Resolution">
                      <div
                        className={classnames({
                          ConfigHistory_ResolutionFilter_Box: true,
                          configHistory_Disabled_Button: fetching
                        })}
                      >
                        <Dropdown
                          selectItem={(label) => this.handleResolutionSelect(label)}
                          title={
                            savedDataConfigs && savedDataConfigs.resolution
                              ? savedDataConfigs.resolution.find((item) => item.active === true).label
                              : 'No resolution selected'
                          }
                          data={resolutionOptions}
                        />
                      </div>
                    </div>
                    <div label="Parameters" checkbox={false}>
                      <div className="kpisFilter_Box">
                        {paramCheckboxItems && paramCheckboxItems.length > 0 ? paramCheckboxes : null}
                      </div>
                    </div>

                    <div label="KPIs">
                      <div className="kpisFilter_Box">
                        {kpisCheckboxItems && kpisCheckboxItems.length > 0 && (
                          <PerfectScrollbar>{kpisCheckboxes}</PerfectScrollbar>
                        )}
                      </div>
                    </div>
                  </Accordion>
                </div>
              </div>
              <div className="configHistory_RightSection">
                {view !== ConfigHistoryViewSwitchStates.CHART && (
                  <div
                    className="configHistory_TableSection"
                    style={{ maxHeight: `${view === ConfigHistoryViewSwitchStates.LIST ? 989 : 310}px` }}
                  >
                    <div className="exportButtonContainer">
                      <IconButton
                        variant="link"
                        color="primary"
                        size="medium"
                        className="exportButton"
                        disabled={fetching}
                        onClick={() => this.exportData(filteredLocalCountersData)}
                        aria-label="Export"
                        data-tip="export table data"
                      >
                        <ExportIcon />
                      </IconButton>
                    </div>
                    {this.state.isDraggingSlider ? (
                      LOADING_CIRCLE
                    ) : (
                      <ScrollReactTable
                        key={this.state.updateTableKey}
                        showPagination={false}
                        resizable={true}
                        sortable={true}
                        minRows={view === ConfigHistoryViewSwitchStates.LIST ? 23 : 6}
                        noDataText={''}
                        fetching={fetching}
                        className={'-highlight configHistory_Table Global_Table'}
                        defaultPageSize={0}
                        pageSize={pageSize <= 11 ? 11 : pageSize}
                        getTdProps={() => {
                          return {
                            onClick: (e, handleOriginal) => {
                              if (handleOriginal) {
                                handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
                              }
                            }
                          };
                        }}
                        data={
                          filteredLocalCountersData && !this.state.isDraggingSlider ? filteredLocalCountersData : []
                        }
                        columns={[...columns(this), ...countersColumns, ...exportColumn]}
                        overlay={overlay}
                        withFixedColumns={true}
                      />
                    )}
                  </div>
                )}
                {view !== ConfigHistoryViewSwitchStates.LIST && (
                  <div className="configHistory_ChartSection">
                    <div className="exportButtonContainer">
                      <IconButton
                        variant="link"
                        color="primary"
                        size="medium"
                        disabled={fetching}
                        className="exportButton"
                        onClick={() => this.exportData(filteredLocalCountersData)}
                        aria-label="Export"
                        data-tip="export table data"
                      >
                        <ExportIcon />
                      </IconButton>
                    </div>
                    {this.state.isDraggingSlider ? (
                      LOADING_CIRCLE
                    ) : (
                      <ConfigHistoryChart
                        deviceId={this.props.deviceId}
                        height={view === ConfigHistoryViewSwitchStates.CHART ? 500 : 295}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setDropModalOpen,
  doGetAvailablePmCounters,
  doGetAvailableCmCounters,
  updateStatus,
  updateConfigHistoryViewSwitch,
  updateConfigHistoryKpiCheckboxItems,
  updateConfigHistoryParamCheckboxItems,
  updateConfigHistoryLocalCountersData,
  updateConfigHistorySelectedCounters,
  updateConfigHistorySavedDataConfigs
};

export default connect((store, ownProps) => {
  const { deviceId } = ownProps;
  const deviceConfigHistory = deviceId && store.ui.singleDevicePage.configHistory[deviceId];
  const pmStatusName = deviceId && `GetCounters-${deviceId}`;

  return {
    page: store.page,
    view: deviceConfigHistory ? deviceConfigHistory.configHisotryViewSwitchState : 0,
    kpisCheckboxItems: deviceConfigHistory && deviceConfigHistory.kpisCheckboxItems,
    paramCheckboxItems: deviceConfigHistory && deviceConfigHistory.paramCheckboxItems,
    getCountersStatus: pmStatusName && store.statuses[pmStatusName],
    localCountersData: deviceConfigHistory && deviceConfigHistory.localCountersData,
    selectedCounters: deviceConfigHistory && deviceConfigHistory.selectedCounters,
    savedDataConfigs: deviceConfigHistory && deviceConfigHistory.savedDataConfigs
  };
}, mapDispatchToProps)(ConfigHistory);
